var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchievements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F3E8FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20855_4113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 17.5H13.7498C13.1973 17.5 12.6674 17.2805 12.2767 16.8898C11.886 16.4991 11.6665 15.9692 11.6665 15.4166C11.6665 14.8641 11.886 14.3342 12.2767 13.9435C12.6674 13.5528 13.1973 13.3333 13.7498 13.3333H14.9998",
    stroke: "#9810FA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 17.5H26.25C26.8025 17.5 27.3324 17.2805 27.7231 16.8898C28.1138 16.4991 28.3333 15.9692 28.3333 15.4166C28.3333 14.8641 28.1138 14.3342 27.7231 13.9435C27.3324 13.5528 26.8025 13.3333 26.25 13.3333H25",
    stroke: "#9810FA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 28.3333H26.6668",
    stroke: "#9810FA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 22.2167V24.1667C18.3335 24.625 17.9418 24.9833 17.5252 25.175C16.5418 25.625 15.8335 26.8667 15.8335 28.3333",
    stroke: "#9810FA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 22.2167V24.1667C21.6665 24.625 22.0582 24.9833 22.4748 25.175C23.4582 25.625 24.1665 26.8667 24.1665 28.3333",
    stroke: "#9810FA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 11.6667H15V17.5C15 18.8261 15.5268 20.0979 16.4645 21.0356C17.4021 21.9732 18.6739 22.5 20 22.5C21.3261 22.5 22.5979 21.9732 23.5355 21.0356C24.4732 20.0979 25 18.8261 25 17.5V11.6667Z",
    stroke: "#9810FA",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20855_4113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchievements);
export default __webpack_public_path__ + "static/media/achievements.a81c3dbecdc407a28cdef67da0b6ef25.svg";
export { ForwardRef as ReactComponent };